export enum PlanFormSteps {
  OVERVIEW = 1,
  HOME_DETAILS = 2,
  FLOOR_PLAN = 3,
  UPLOADS = 4,
  BULK_ELEVATIONS = 5
}
